<ng-template #pending>
    <app-loading-dots></app-loading-dots>
</ng-template>

<div class="container">
    <div class="col-12">
        <div class="row center">
            <div class="wrapper col-12 col-md-8 col-lg-6">
                <app-spot-headline
                    class="center-text"
                    *ngIf="data.headlineText as headlineText"
                    [index]="data.spotIndex"
                >
                    {{ headlineText }}
                </app-spot-headline>

                <div
                    class="rich-text center-text"
                    *ngIf="data.richText as richText"
                    [innerHTML]="richText | safe: 'html'"
                ></div>
                <form (submit)="onSubmit(balance)">
                    <div class="controls">
                        <app-input
                            class="input-gift-card"
                            marginBottom="none"
                            [control]="balance"
                            autocomplete="off"
                            [label]="'forms.labels.giftcardCode' | translateSafe"
                            [placeholder]="'forms.labels.giftcardCode' | translateSafe"
                        ></app-input>
                        <button class="kk-btn" type="submit" [disabled]="pending$ | async">
                            <ng-container *ngIf="(pending$ | async) === false; else pending">{{
                                'general.action.seeBalance' | translateSafe
                            }}</ng-container>
                        </button>
                    </div>

                    <div class="feedback center-text">
                        <ng-container *ngIf="(pending$ | async) === false; else pending">
                            <ng-container *ngIf="balanceResponse$ | async as balance">
                                <p
                                    *ngIf="balance === 'error'"
                                    class="feedback-error"
                                    [innerHTML]="'message.giftcardCheckValidationError' | translateSafe"
                                ></p>
                                <p
                                    *ngIf="balance !== 'error'"
                                    [innerHTML]="
                                        'general.validation.giftcardBalance'
                                            | translateSafe: { balance: balance?.discount }
                                    "
                                ></p>
                            </ng-container>
                        </ng-container>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
